import { access } from "./fsLimit.js";
async function checkPathExists(path) {
  try {
    await access(path);
    return true;
  } catch {
    return false;
  }
}
export {
  checkPathExists
};
//# sourceMappingURL=checkPathExists.js.map
